import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import * as state from '@/components/Analysis/state';
import { FocalPoint } from '@/types';
import { AssemblyCameraPose } from '@/__generated__/graphql';

export const useSetFocalPointByAssembly = (
  assemblyName: string | undefined,
  focalPoint: FocalPoint | undefined,
  cameraPose: AssemblyCameraPose | undefined
) => {
  const setFocalPointsByAssemblyId = useSetAtom(state.focalPointsByAssemblyId);

  useEffect(() => {
    if (!assemblyName) {
      return;
    }
    if (!focalPoint && !cameraPose) return;

    setFocalPointsByAssemblyId((current) => {
      const newFocalPoints = { ...current };
      newFocalPoints[assemblyName] = { focalPoint, cameraPose };
      return newFocalPoints;
    });
  }, [assemblyName, setFocalPointsByAssemblyId, focalPoint, cameraPose]);
};
